<template>
  <div class="fashion-icon-loader flex flex-center">
    <q-icon
      :name="icon"
      :size="size"
      :color="color"
      class="fashion-animate"
    />    
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    size: {
      type: String,
      default: '40px'
    },
    color: {
      type: String,
      default: 'grey-7'
    }
  },

  data () {
    return {
      intervalId: null,
      icons: [
        'mdi-tshirt-v',        
        'mdi-shoe-sneaker',
        'mdi-underwear-outline',
        'mdi-shoe-cleat',
        'mdi-tshirt-v-outline',
        'mdi-soccer'            
      ],
      icon: ''
    }
  },

  mounted () {
    const firtChange = this.icons[Math.floor(Math.random() * this.icons.length)]
    this.icon = firtChange    
    this.intervalId = setInterval(() => {
      this.changeIcon(false)
    }, 2000)    
  },
  unmounted () {
    clearInterval(this.intervalId)    
  },
  methods: {    
    changeIcon () {
      this.icon = 
        this.icons[
          (this.icons.indexOf(this.icon) + 1) % this.icons.length
        ]
    }
  }
}
</script>

<style scoped>
.fashion-icon-loader {
  min-height: 60px;
}
.fashion-animate {    
  animation: fashion-spin 1.3s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

@keyframes fashion-spin {
  0% {
    transform: rotate(0deg) scale(1);
    opacity: 0.85;
  }
  50% {
    transform: rotate(180deg) scale(1.1);
    opacity: 1;
  }
  100% {
    transform: rotate(360deg) scale(1);
    opacity: 0.85;
  }
}
</style>